import { createElement } from "react";
import React from "react";
import * as react from "react";
import { Interop_reactApi } from "../fable_modules/Feliz.2.7.0/Interop.fs.js";
import { equals, createObj } from "../fable_modules/fable-library-js.4.17.0/Util.js";
import { empty, singleton, append, delay, toList } from "../fable_modules/fable-library-js.4.17.0/Seq.js";
import { append as append_1, ofArray } from "../fable_modules/fable-library-js.4.17.0/List.js";
import { defaultOf } from "../fable_modules/fable-library-js.4.17.0/Util.js";
import { useFeliz_React__React_useState_Static_1505, React_createDisposable_3A5B6456, useReact_useEffect_Z5ECA432F, useReact_useRef_1505, useReact_useEffectOnce_3A5B6456 } from "../fable_modules/Feliz.2.7.0/React.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { printf, toText } from "../fable_modules/fable-library-js.4.17.0/String.js";
import { class_type } from "../fable_modules/fable-library-js.4.17.0/Reflection.js";

export function Accordion_accordion(children) {
    return createElement("div", {
        style: {
            display: "flex",
            flexDirection: "column",
        },
        children: Interop_reactApi.Children.toArray(Array.from(children)),
    });
}

export function Accordion_accordionHeader(title, isActive, onClick) {
    let elems;
    return createElement("button", createObj(ofArray([["style", createObj(toList(delay(() => append(singleton(["backgroundColor", "#FFFFFF"]), delay(() => append(singleton(["color", "var(--text-main)"]), delay(() => append(singleton(["cursor", "pointer"]), delay(() => append(singleton(["padding", 10]), delay(() => append(singleton(["width", 100 + "%"]), delay(() => append(singleton(["textAlign", "left"]), delay(() => append(singleton(["border", "none"]), delay(() => append(singleton(["outline", "none"]), delay(() => append(singleton(["transition", "0.4s"]), delay(() => append(singleton(["display", "flex"]), delay(() => append(singleton(["justifyContent", "space-between"]), delay(() => append(singleton(["alignItems", "center"]), delay(() => (isActive ? singleton(["borderBottom", (((1 + "px ") + "solid") + " ") + "var(--text-dim)"]) : empty()))))))))))))))))))))))))))))], ["onClick", (_arg) => {
        onClick();
    }], (elems = [createElement("span", {
        children: [title],
    }), createElement("i", {
        className: isActive ? "fas fa-minus" : "fas fa-plus",
    })], ["children", Interop_reactApi.Children.toArray(Array.from(elems))])])));
}

export function Accordion_panel(isActive, children) {
    return createElement("div", {
        style: createObj(toList(delay(() => append(singleton(["padding", ((0 + "px ") + 10) + "px"]), delay(() => append(singleton(["backgroundColor", "#FFFFFF"]), delay(() => append(!isActive ? singleton(["maxHeight", 0]) : singleton(["maxHeight", 400]), delay(() => append(singleton(["overflow", "hidden"]), delay(() => append(singleton(["width", 100 + "%"]), delay(() => singleton(["transition", "max-height 0.2s ease-out"])))))))))))))),
        children: Interop_reactApi.Children.toArray(Array.from(children)),
    });
}

export function Accordion_panelActions(children) {
    return createElement("div", {
        style: {
            display: "flex",
            justifyContent: "flex-end",
            gap: 10 + "px ",
            padding: 10,
        },
        children: Interop_reactApi.Children.toArray(Array.from(children)),
    });
}

export function Alert_alert(msg, onClose) {
    let elems;
    return createElement("div", createObj(ofArray([["className", "alert-error"], ["onClick", (_arg) => {
        onClose();
    }], (elems = [createElement("i", {
        className: "fas fa-exclamation-triangle",
        style: {
            marginRight: 5,
        },
    }), createElement("span", {
        children: [msg],
    })], ["children", Interop_reactApi.Children.toArray(Array.from(elems))])])));
}

export function Alert_errorAlert(errMsg, dismiss) {
    if (errMsg != null) {
        return Alert_alert(errMsg, dismiss);
    }
    else {
        return defaultOf();
    }
}

export function Alert_SnackError(alert_SnackErrorInputProps) {
    let elems;
    const dismiss = alert_SnackErrorInputProps.dismiss;
    const errMsg = alert_SnackErrorInputProps.errMsg;
    useReact_useEffectOnce_3A5B6456(() => {
        const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => ((new Promise(resolve => setTimeout(resolve, 10000))).then(() => {
            dismiss();
            return Promise.resolve();
        }))));
        pr.then();
    });
    return createElement("div", createObj(ofArray([["className", "snackbar"], ["onClick", (_arg_2) => {
        dismiss();
    }], (elems = [Alert_alert(errMsg, dismiss)], ["children", Interop_reactApi.Children.toArray(Array.from(elems))])])));
}

export function Alert_snackError(errMsg, dismiss) {
    if (errMsg != null) {
        const errMsg_1 = errMsg;
        return createElement(Alert_SnackError, {
            errMsg: errMsg_1,
            dismiss: dismiss,
        });
    }
    else {
        return defaultOf();
    }
}

export function Button_pillButton(title, onClick, styles) {
    return createElement("button", {
        onClick: onClick,
        className: "pill-button",
        style: createObj(styles),
        children: title,
    });
}

export function Button_cancelButton(title, onClick, styles) {
    return createElement("button", {
        onClick: onClick,
        className: "cancel-pill-button",
        style: createObj(styles),
        children: title,
    });
}

export function Button_cancelButtonSmall(title, onClick, styles) {
    let elems;
    return createElement("button", createObj(ofArray([["className", "cancel-pill-button-small"], ["style", createObj(styles)], ["onClick", onClick], (elems = [createElement("span", {
        style: {
            textAlign: "center",
        },
        children: title,
    })], ["children", Interop_reactApi.Children.toArray(Array.from(elems))])])));
}

export function Button_pillButtonSmall(title, onClick, styles) {
    let elems;
    return createElement("button", createObj(ofArray([["className", "pill-button-small"], ["style", createObj(styles)], ["onClick", onClick], (elems = [createElement("span", {
        style: {
            textAlign: "center",
        },
        children: title,
    })], ["children", Interop_reactApi.Children.toArray(Array.from(elems))])])));
}

export function Button_smallIconButton(className, onClick) {
    let elems;
    return createElement("button", createObj(ofArray([["style", {
        cursor: "pointer",
        margin: 0,
        marginRight: 4,
        padding: 0,
        border: "none",
        background: "none",
        height: 18,
        width: 18,
    }], ["onClick", onClick], (elems = [createElement("i", {
        className: className,
    })], ["children", Interop_reactApi.Children.toArray(Array.from(elems))])])));
}

export function Button_groupButtonLeft(isActive, onClick, children) {
    return createElement("button", {
        className: isActive ? "grouped-button-left grouped-button-active" : "grouped-button-left",
        onClick: onClick,
        children: Interop_reactApi.Children.toArray(Array.from(children)),
    });
}

export function Button_groupButtonCenter(isActive, onClick, children) {
    return createElement("button", {
        className: isActive ? "grouped-button-center grouped-button-active" : "grouped-button-center",
        onClick: onClick,
        children: Interop_reactApi.Children.toArray(Array.from(children)),
    });
}

export function Button_groupButtonRight(isActive, onClick, children) {
    return createElement("button", {
        className: isActive ? "grouped-button-right grouped-button-active" : "grouped-button-right",
        onClick: onClick,
        children: Interop_reactApi.Children.toArray(Array.from(children)),
    });
}

export function Dialog_dialogTitle(txt) {
    let elems;
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        gap: 20 + "px ",
        alignItems: "center",
    }], (elems = [createElement("span", {
        style: {
            fontSize: 1.2 + "rem",
            fontWeight: 500,
        },
        children: txt,
    })], ["children", Interop_reactApi.Children.toArray(Array.from(elems))])])));
}

export function Dialog_dialogContent(children) {
    return createElement("div", {
        style: {
            display: "flex",
            flexDirection: "column",
            gap: ((20 + "px ") + 20) + "px",
        },
        children: Interop_reactApi.Children.toArray(Array.from(children)),
    });
}

export function Dialog_dialogActions(children) {
    return createElement("div", {
        style: {
            display: "flex",
            gap: 20 + "px ",
            alignItems: "center",
            justifyContent: "flex-end",
        },
        children: Interop_reactApi.Children.toArray(Array.from(children)),
    });
}

export function Dialog_Dialog(dialog_DialogInputProps) {
    let elems_1;
    const children = dialog_DialogInputProps.children;
    const onClose = dialog_DialogInputProps.onClose;
    const ref = useReact_useRef_1505(undefined);
    const closeEffect = (event) => {
        onClose();
    };
    useReact_useEffect_Z5ECA432F(() => {
        window.addEventListener("onclick", closeEffect);
        return React_createDisposable_3A5B6456(() => {
            window.removeEventListener("onclick", closeEffect);
        });
    });
    return createElement("div", createObj(ofArray([["ref", ref], ["className", "dialog-backdrop"], ["onClick", (event_1) => {
        if (equals(event_1.target, ref.current)) {
            window.removeEventListener("onclick", closeEffect);
            onClose();
        }
    }], (elems_1 = [createElement("div", {
        className: "dialog",
        children: Interop_reactApi.Children.toArray(Array.from(children)),
    })], ["children", Interop_reactApi.Children.toArray(Array.from(elems_1))])])));
}

export function Image_avatar(src, size) {
    let elems;
    return createElement("div", createObj(ofArray([["className", "user-avatar"], ["style", {
        width: size + "px",
        height: size + "px",
    }], (elems = [createElement("img", {
        alt: "User image",
        src: src,
    })], ["children", Interop_reactApi.Children.toArray(Array.from(elems))])])));
}

export function Image_iconAvatar(size, icon) {
    let elems;
    return createElement("div", createObj(ofArray([["className", "user-avatar"], ["style", {
        width: size + "px",
        height: size + "px",
    }], (elems = [createElement("i", {
        className: icon,
    })], ["children", Interop_reactApi.Children.toArray(Array.from(elems))])])));
}

export function Image_userCircle(userId, size, isLarge, randHash) {
    let arg_1, arg_2;
    return Image_avatar((arg_1 = (isLarge ? "normal" : "small"), (arg_2 = ((randHash != null) ? (`&r=${randHash}`) : ""), toText(printf("/api/user/image/%i?size=%s%s"))(userId)(arg_1)(arg_2))), size);
}

export function Image_circledImage(size, imgUrl) {
    return Image_avatar(imgUrl, size);
}

export function Text_usernameText(x, postRemoved) {
    if (!postRemoved) {
        const xs_3 = toList(delay(() => append(singleton(createElement("a", {
            href: `/user/${x.Username}`,
            children: createElement("span", {
                style: {
                    color: "var(--bg-dark)",
                    fontWeight: 500,
                },
                children: x.Username,
            }),
        })), delay(() => (x.Official ? singleton(createElement("span", {
            style: {
                marginLeft: 5,
                color: "var(--text-main)",
                fontSize: 0.8 + "rem",
            },
            className: "fas fa-shield-alt",
        })) : empty())))));
        return react.createElement(react.Fragment, {}, ...xs_3);
    }
    else {
        return createElement("span", {
            children: x.Username,
        });
    }
}

export function Tooltip_Tooltip(tooltip_TooltipInputProps) {
    let elems;
    const children = tooltip_TooltipInputProps.children;
    const txt = tooltip_TooltipInputProps.txt;
    const patternInput = useFeliz_React__React_useState_Static_1505(false);
    const active = patternInput[0];
    return createElement("div", createObj(ofArray([["onClick", (_arg) => {
        patternInput[1](!active);
    }], ["className", "tooltip"], (elems = [children, createElement("span", {
        className: active ? "tooltip-text tooltip-text-active" : "tooltip-text",
        children: txt,
    })], ["children", Interop_reactApi.Children.toArray(Array.from(elems))])])));
}

export function Tooltip_wrapTooltip(x, y) {
    return createElement(Tooltip_Tooltip, {
        txt: x,
        children: y,
    });
}

export function Tooltip_tooltipHeader(header, tooltipTitle) {
    let elems;
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        alignItems: "center",
    }], (elems = [createElement("span", {
        style: {
            color: "var(--text-main)",
            fontStyle: "italic",
            paddingLeft: 7,
        },
        children: header,
    }), createElement(Tooltip_Tooltip, {
        txt: tooltipTitle,
        children: createElement("span", {
            style: {
                color: "var(--text-dim)",
                marginLeft: 7,
            },
            className: "fas fa-question-circle",
        }),
    })], ["children", Interop_reactApi.Children.toArray(Array.from(elems))])])));
}

function Checkbox_checkboxHolder(children) {
    return createElement("label", {
        className: "checkbox-holder",
        children: Interop_reactApi.Children.toArray(Array.from(children)),
    });
}

export function Checkbox_checkbox(title, active, onChange) {
    let elems_1, elems;
    return Checkbox_checkboxHolder(ofArray([createElement("span", createObj(ofArray([["className", "checkbox-holder-span"], (elems_1 = [createElement("input", {
        type: "checkbox",
    }), createElement("span", createObj(ofArray([["onClick", (_arg) => {
        onChange(!active);
    }], ["className", active ? "checkbox-checkmark-background checkbox-checkmark-background-active" : "checkbox-checkmark-background"], (elems = toList(delay(() => (active ? singleton(createElement("span", {
        className: "checkbox-checkmark",
    })) : empty()))), ["children", Interop_reactApi.Children.toArray(Array.from(elems))])])))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_1))])]))), createElement("span", {
        onClick: (_arg_1) => {
            onChange(!active);
        },
        children: title,
    })]));
}

export function Checkbox_termsOfUse(active, onChange) {
    let elems_1, elems, children;
    return Checkbox_checkboxHolder(ofArray([createElement("span", createObj(ofArray([["className", "checkbox-holder-span"], (elems_1 = [createElement("input", {
        type: "checkbox",
    }), createElement("span", createObj(ofArray([["onClick", (_arg) => {
        onChange(!active);
    }], ["className", active ? "checkbox-checkmark-background checkbox-checkmark-background-active" : "checkbox-checkmark-background"], (elems = toList(delay(() => (active ? singleton(createElement("span", {
        className: "checkbox-checkmark",
    })) : empty()))), ["children", Interop_reactApi.Children.toArray(Array.from(elems))])])))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_1))])]))), (children = ofArray([createElement("span", {
        onClick: (_arg_1) => {
            onChange(!active);
        },
        style: {
            color: "var(--text-main)",
        },
        children: "Jeg har lest og aksepterer ",
    }), createElement("a", {
        style: {
            textDecoration: "underline",
        },
        target: "_blank",
        href: "/terms-of-use",
        children: "brukervilkårene",
    })]), createElement("span", {
        children: Interop_reactApi.Children.toArray(Array.from(children)),
    }))]));
}

export function LoadingIndicator_skeleton(styles) {
    return createElement("div", {
        className: "skeleton",
        style: createObj(styles),
    });
}

export function LoadingIndicator_postLoadingIndicator() {
    return LoadingIndicator_skeleton(ofArray([["height", 248], ["width", 100 + "%"]]));
}

export function LoadingIndicator_loadingIndicatorSmall() {
    return createElement("div", {
        className: "loading",
        style: {
            width: 20,
            height: 20,
        },
    });
}

export function LoadingIndicator_loadingIndicator() {
    return createElement("div", {
        className: "loading",
        style: {
            width: 30,
            height: 30,
        },
    });
}

export class Select_Select {
    constructor() {
    }
}

export function Select_Select_$reflection() {
    return class_type("Aksjeio.Components.Select.Select", undefined, Select_Select);
}

export class TextField_TextField {
    constructor() {
    }
}

export function TextField_TextField_$reflection() {
    return class_type("Aksjeio.Components.TextField.TextField", undefined, TextField_TextField);
}

export function TextField_TextField_textField(defaultValue, onChange, props) {
    return createElement("input", createObj(append_1(ofArray([["type", "text"], ["defaultValue", defaultValue], ["onChange", (ev) => {
        onChange(ev.target.value);
    }], ["className", "textfield"]]), props)));
}

